import { render } from "./QrcodeConfig.vue?vue&type=template&id=12b1efae&scoped=true"
import script from "./QrcodeConfig.vue?vue&type=script&lang=js"
export * from "./QrcodeConfig.vue?vue&type=script&lang=js"

import "./QrcodeConfig.vue?vue&type=style&index=0&id=12b1efae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b1efae"]])

export default __exports__